import React from 'react';
import { connect, ConnectedProps } from 'react-redux';
import { Route, RouteProps } from 'react-router-dom';
import * as Core from '../../core';
import { ApplicationState } from '../..';
import userManager from '../userManager';
import AnonymousUser from './AnonymousUser';
import UserExpired from './UserExpired';

const connector = connect(
    (state: ApplicationState) => state.core,
    Core.actions
)
type PropsFromRedux = ConnectedProps<typeof connector>

type PrivateRouteProps = 
    RouteProps &
    PropsFromRedux

class PrivateRoute extends Route<PrivateRouteProps> {
    
    componentDidMount() {
        userManager.events.addAccessTokenExpiring(this.props.userExpired);
        userManager.events.addAccessTokenExpired(this.props.userExpired);
    }

    componentWillUnmount() {
        userManager.events.removeAccessTokenExpiring(this.props.userExpired);
        userManager.events.removeAccessTokenExpired(this.props.userExpired);
    }

    render() {
        if (this.props.auth.expired) {
            return <UserExpired />;
        } else if (!this.props.auth.loggedIn) {
            return <AnonymousUser />;
        } else  {
            return <Route {...this.props}/>;
        }
    }
}

export default connector(PrivateRoute)